import { TextField, Button, Typography, Link } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import { useAuth } from 'reactfire';
import { AuthError } from 'firebase/auth';
import * as yup from 'yup';

import { AuthContainer, AuthForm } from '../../styled/AuthPage.styled';
import { login, handleAuthError } from '../../utils/api/auth';

const loginSchema = yup.object().shape({
  email: yup.string().email('Неправильний email').required('Обов’язкове поле'),
  password: yup
    .string()
    .min(8, 'Пароль має бути не коротшим ніж 8 символів')
    .required('Обов’язкове поле'),
});

const LoginPage = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: loginSchema,
    async onSubmit({ email, password }, { setErrors }) {
      try {
        await login(auth, email, password);

        navigate('/dashboard');
      } catch (error) {
        const message = handleAuthError(error as AuthError);

        setErrors({ email: message });
      }
    },
  });

  return (
    <AuthContainer maxWidth="xs">
      <Typography variant="h5" marginBottom={3}>
        Вхід
      </Typography>
      <AuthForm onSubmit={formik.handleSubmit}>
        <TextField
          id="email"
          name="email"
          autoComplete="email"
          label="Email"
          autoFocus
          value={formik.values.email}
          onChange={formik.handleChange}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
        />
        <TextField
          id="password"
          name="password"
          type="password"
          label="Пароль"
          value={formik.values.password}
          onChange={formik.handleChange}
          error={formik.touched.password && Boolean(formik.errors.password)}
          helperText={formik.touched.password && formik.errors.password}
        />
        <Link
          to="/forgot-password"
          component={RouterLink}
          display="flex"
          justifyContent="flex-end"
        >
          Забули пароль?
        </Link>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          disabled={formik.isSubmitting}
        >
          Увійти
        </Button>
        <Typography>
          Ще не маєте аккаунта?&nbsp;
          <Link to="/register" component={RouterLink}>
            Зареєструватися
          </Link>
        </Typography>
      </AuthForm>
    </AuthContainer>
  );
};

export default LoginPage;
